import type {
  ComponentPropsWithoutRef,
  CSSProperties,
  ReactNode,
} from "react";

import { Label } from "./styled";

export interface TextSpanProps
  extends Omit<ComponentPropsWithoutRef<"span">, "color" | "children"> {
  color?: string;
  display?: CSSProperties["display"];
  children?: ReactNode;
}

export const TextSpan = ({
  color,
  display,
  children,
  title,
  ...rest
}: TextSpanProps) => {
  const resolvedTitle =
    title ??
    (typeof children === "string" || typeof children === "number"
      ? String(children)
      : undefined);

  return (
    <Label
    
      title={resolvedTitle}
      color={color}
      display={display}
      {...rest}
    >
      {children}
    </Label>
  );
};